module.exports = __webpack_public_path__ + "img/FullbackLight2.5857cd9a.jpg";